<template>
    <div>
        <div class="line__vertical-mains"></div>
        <button-back/>
        <div v-if="locations.length > 0" class="map_filter">
            <div class="maphighlight__box">
                <h1 class="caption__select">
                    <span>{{img.name}}</span>
                    <span>Seleccione un nivel, clic para ver detalles</span>
                </h1>
                <map-highlight-deptos :img="img" :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type" :nivel="nivel" />
                <!-- <Button :img="img" :id="id" :desarrollo="desarrollo" :nivel="nivel"  :levelId="levelId" :url="url"/>-->
                <div class="line_horizontal"></div>
                <Availables class="availables-mobile" :desarrollo="desarrollo" :filterPrice="rangeFilterPrice" :filterPriceDtos="rangeFilterPrices"  :type="type" :existFilter="existFilter" @onUpdateModel="updateActiveModel" />
            </div>
            <div class="select__box">
                <Availables class="availables-desk" :desarrollo="desarrollo" :filterPrice="rangeFilterPrice" :filterPriceDtos="rangeFilterPrices" :type="type" :existFilter="existFilter" @onUpdateModel="updateActiveModel" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MapHighlightDeptos from "../../core/MapHighlightDeptos";
import ButtonBack from "../../core/ButtonBack";
//import Button from "../../../core/Button.vue";
import Availables from "../../core/Availables.vue";

export default {
    name: "Main",
    components: {
        MapHighlightDeptos,
        //Button,
        ButtonBack,
        Availables
    },
    data() {
        return {
            id: this.$route.params.id,
            levelId: 0,
            type: "departamentos",
            desarrollo: "torrespanorama",
            arrFilteredLocations: [],
            nivel: "towerStageLevel",
            url: `cve_torre_etapa=${this.$route.params.id}`,
            torres: {
                TORREA: {
                    name: 'TORRE A',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespanorama/TORREA/TorreA.png',
                    width: '1080',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '608',
                    transform: '',
                    viewBox: '0 0 1080 608'
                },
                TORREB: {
                    name: 'TORRE B',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespanorama/TORREB/TorreB.png',
                    width: '1080',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '608',
                    transform: '',
                    viewBox: '0 0 1080 608'
                },
                TORREC: {
                    name: 'TORRE C',
                    url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/torrespanorama/TORREC/TorreC.png',
                    width: '1080',
                    id: this.$route.params.id,
                    levelId: 0,
                    nivel: 'towerStageLevel',
                    route: `cve_torre_etapa=${this.$route.params.id}`,
                    height: '608',
                    transform: '',
                    viewBox: '0 0 1080 608'
                },

            },
            // si no hay filtro volver rangeFilter a false
            rangeFilter: false,
            activeModel: "",
            rangeFilterPriceTA:[3809135,5185844],
            rangeFilterPricesTA:{
                'PISO 1':[5185844,4566023.27],
                'PISO 2':[3922400,3839721.87],
                'PISO 3':[3927450,3809135],
                /* 'PISO 4':[3909400,3600554.75],
                'PISO 5':[3656550,3321500],
                'PISO 6':[3477600,3290100],
                'PISO 7':[4061925.04,3341500], */
            },
            rangeFilterPriceTB:[4050042,4865677],
            rangeFilterPricesTB:{
                'PISO 1':[4075307.11,5004652.88],
                'PISO 2':[4865677,4082464.78],
                'PISO 3':[4050042],
                'PISO 4':[4057942.92],
                'PISO 5':[4519958.39],
                /* 'PISO 6':[6733756,6733756],
                'PISO 7':[6537391,6537391], */
            },
            rangeFilterPriceTC:[3961500,4988948],
            rangeFilterPricesTC:{
                'PISO 1':[4988948,4359236.02],
                'PISO 2':[4761744.86,3993310.74],
                'PISO 3':[3961500],
                'PISO 4':[3969251.55],
                'PISO 5':[4438322.34],
                'PISO 6':[4223031.89,3997879.78],
                'PISO 7':[4224402.03],
            }
        };
    },
    computed: {
        ...mapGetters({
            locations: "getLocations",
            filterModelos: "getStatusFilterModelos"
        }),
        development() {
            return { id: this.id, level: this.levelId };
        },
        img() {
            const torre = this.$route.params.torre;
            const torreSeleccionada = this.torres[torre];
            return torreSeleccionada;
        },
        amountAvailables() {
            const filteredAvailables = this.existFilter;
            const newArrfiltered = filteredAvailables.filter(
                (item) => item.status == 2
            );
            return newArrfiltered;
        },
        rangeFilterPrice(){
            let selectRangeFileter
            if (this.$route.params.id == 61) {
                selectRangeFileter = this.rangeFilterPriceTA
            } else if (this.$route.params.id == 62) {
                selectRangeFileter = this.rangeFilterPriceTB
            }else if (this.$route.params.id == 63) {
                selectRangeFileter = this.rangeFilterPriceTC
            }
            return selectRangeFileter
        },
        rangeFilterPrices(){
            let selectRangeFileter
            if (this.$route.params.id == 61) {
                selectRangeFileter = this.rangeFilterPricesTA
            } else if (this.$route.params.id == 62) {
                selectRangeFileter = this.rangeFilterPricesTB
            }else if (this.$route.params.id == 63) {
                selectRangeFileter = this.rangeFilterPricesTC
            }
            return selectRangeFileter
        },
        existFilter() {
            return this.locations
        },
    },
    methods: {
        ...mapActions(["getTowerStageLevels", "clearCoords", "getFilterModelos"]),
        changeRange(arrFilter) {
            this.arrFilteredLocations = arrFilter;
        },
        updateActiveModel(model) {
            this.getFilterModelos(model);
        }
    },
    async created() {
        await this.getTowerStageLevels(this.development);
        this.getFilterModelos(this.existFilter)
    },
    async beforeDestroy() {
        await this.clearCoords();
    },
    mounted() {}
};
</script>
